module.exports = __webpack_public_path__ + "resources/img/equipment_tab3_img3_m.cc4e60bae354a052afea450cf393fa44.jpg";